

























































import {Component, Vue} from 'vue-property-decorator';
import {ObjectFactory} from '../../config/objectFactory';
import {AddMemberRequest} from '../../types/request';
import {validationMixin} from 'vuelidate';
import {email, integer, minLength, required} from 'vuelidate/lib/validators';
import {MedTransGoConstants} from '../../util/constants';
import {ToastEvent} from '../../types/event';
import {CommonUtils} from '../../util/commonUtils';
import {EventBus} from '../../main';
import {OrgLocation} from '../../types/entity';
import {MemberProfile} from '../../types/response';

@Component({
    mixins: [validationMixin],
    data() {
        return {
            fullName: '',
            email: '',
            phone: '',
            memberType: 'ORG_LIEN_CUSTOMER',
            maximumAllowedSubmission: 0,
            isRequestLimit: false,
            isRestrictedView: false,
            isApprovalRequired: false,
        };
    },
    validations() {
        const rules = {
            fullName: {
                required,
                regex: (fullName: string) => /^[a-zA-Z ]+$/.test(fullName),
            },
            email: {
                required,
                email,
            },
            phone: {
                required,
                minLength: minLength(10),
                regex: (phone: string) => MedTransGoConstants.PHONE_REGX.test(phone),
            },
        };
        return rules;
    },
})
export default class AddChildMemberModal extends Vue {
    private show = true;

    private locations: OrgLocation[] | undefined = [];
    private isLienEnabled = false;
    private memberProfile: MemberProfile | undefined;
    private isMemberType = false;

    public mounted() {
        this.memberProfile = ObjectFactory.getCacheService().getMemberInfo();
    }

    /**
     * @author <Aniket.P>
     * @description API - Returns organization locations
     * @param req {Request} - Express Request
     * @param res {Response} - Express Response - list of locations
     * @returns List of oragnazation lists
     * @throws InvalidRequestException if organization id is invalid
     */
    private async getOrganizationLocations() {
        if (!this.locations || this.locations.length <= 0) {
            const memberProfile = ObjectFactory.getCacheService().getValue(
                MedTransGoConstants.FIELD_MEMBER_PROFILE,
            ) as MemberProfile;
            if (memberProfile.organization) {
                const response = await ObjectFactory.getOrganizationService().getLocations(this.$store.state.serverUrl);
                if (response.success) {
                    this.locations = response.data;
                } else {
                    CommonUtils.showError(response);
                }
            }
        }
    }

    private async getOrganization() {
        const organization = await ObjectFactory.getOrganizationService().
        getOrgDetailsById(this.$store.state.serverUrl);
        if (organization && organization.data && organization.data.lienCustomerEnabled) {
            this.isLienEnabled = true;
        }
    }

    /**
     * @author <Amol.D>
     * @description - add new member
     * @param req {Request} - calls add member API
     * @param res {Response} - Express Response - success result
     * @returns member list
     * @throws InvalidRequestException if member already exists
     */
    private async addMember() {
        if (this.memberProfile) {
            const addMemberRequest: AddMemberRequest = {
            fullName: this.$data.fullName,
            email: this.$data.email,
            phone: this.$data.phone,
            locationId: this.memberProfile.location ? this.memberProfile.location.id : '',
            managedLocationIds: (this.memberProfile.managedLocations || []).map((ml: OrgLocation) => ml.id),
            memberType: this.$data.memberType,
            maximumAllowedSubmission: this.$data.maximumAllowedSubmission,
            parentMemberId: this.memberProfile.memberId,
            };
            const response = await ObjectFactory.getMemberService().addMember(this.$store.state.serverUrl,
                addMemberRequest);
            if (response.success) {
                const toastEvent: ToastEvent = {
                    message: CommonUtils.translateMessageCode('MSG_ADD_MEMBER'),
                    title: 'Success!',
                    timeout: 2000,
                    varient: 'success',
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
                this.close();
            } else {
                CommonUtils.showError(response);
            }
        }
    }

    private async phoneNumberMask() {
        const replaceInput = this.$data.phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        this.$data.phone = !replaceInput[2] ? replaceInput[1] :
            replaceInput[1] + '-' + replaceInput[2] + (replaceInput[3] ? '-' + replaceInput[3] : '');
    }

    private close() {
        this.$router.push({
            name: MedTransGoConstants.VIEW_SETTING_NAME,
        });
    }
}
